import { render, staticRenderFns } from "./FormatoCurriculumVitae.vue?vue&type=template&id=06be29cc&scoped=true"
import script from "./FormatoCurriculumVitae.vue?vue&type=script&lang=js"
export * from "./FormatoCurriculumVitae.vue?vue&type=script&lang=js"
import style0 from "./FormatoCurriculumVitae.vue?vue&type=style&index=0&id=06be29cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06be29cc",
  null
  
)

export default component.exports